module.exports = __webpack_public_path__ + "static/media/android-chrome-512x512.6c8f9952.png";